export const navLinks = [
  { id: 'about', label: '社区简介' },
  { id: 'entrance', label: '入口类型' },
  { id: 'reason', label: '地址变动' },
  { id: 'guide', label: '访问指南' },
  { id: 'security', label: '安全提示' },
  { id: 'faq', label: '常见问题' },
  { id: 'updates', label: '更新说明' },
  { id: 'contact', label: '反馈帮助' },
];

export const heroHighlights = [
  {
    icon: 'ri-links-line',
    title: '多类入口整理',
    desc: '把官网首页、备用地址与移动端入口集中说明，减少来回查找的时间。',
  },
  {
    icon: 'ri-refresh-line',
    title: '变动说明清晰',
    desc: '地址调整之后如何重新找到入口，这里的说明都写得明明白白。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全浏览提醒',
    desc: '识别仿冒页面、保护账号信息，让你访问时更安心、更稳妥。',
  },
];

export const aboutFacts = [
  { value: '官网 / 备用 / 移动', label: '三类入口说明' },
  { value: '10 条', label: '常见问题解答' },
  { value: '5 个步骤', label: '安全访问流程' },
  { value: '持续整理', label: '地址与入口变动' },
];

export const aboutPoints = [
  {
    icon: 'ri-information-line',
    title: '本站提供什么',
    desc: '本站是一份信息整理页，把香蕉社区相关的官网入口、网址首页、备用地址与新地址的查找方式集中呈现，方便需要访问时快速定位。',
  },
  {
    icon: 'ri-user-received-line',
    title: '面向哪些访客',
    desc: '面向第一次听说香蕉社区、想了解如何找到官方入口的新访客，以及原来保存的地址失效、需要重新确认入口的老访客。',
  },
  {
    icon: 'ri-book-open-line',
    title: '内容如何组织',
    desc: '从入口类型、地址变动原因，到访问步骤与安全提醒，按「先了解、再访问、后注意」的顺序铺开，读完即可形成完整判断。',
  },
  {
    icon: 'ri-alert-line',
    title: '使用时的提醒',
    desc: '本站不代替官方发布，任何入口的最终可用性都以官方渠道为准。遇到要求额外付费、索取密码的页面，请先停下来核实。',
  },
];

export const entranceTabs = [
  {
    key: 'official',
    label: '官网入口',
    icon: 'ri-global-line',
    headline: '官网首页入口：从最可靠的来源进入',
    desc: '官网入口指的是由香蕉社区运营方直接对外公布的首页通道，通常是判断一个地址是否可信的第一参考。它一般具备完整的页面结构、统一的视觉风格与稳定的导航，不会在打开瞬间弹出大量陌生窗口。',
    points: [
      '优先通过官方公开渠道获取，而不是来源不明的转发链接',
      '页面结构完整、板块清晰，加载后不会强制跳转到其他站点',
      '留意地址栏与页面标识是否一致，细节不一致时应提高警惕',
      '若官网入口临时无法打开，不要反复刷新陌生页面，改用备用通道',
    ],
    note: '官网入口是可信度最高的来源，但也可能因运营调整而更换，请以官方最新公布为准。',
  },
  {
    key: 'backup',
    label: '备用地址',
    icon: 'ri-route-line',
    headline: '备用地址：主入口不可用时的第二选择',
    desc: '备用地址是在主入口暂时无法访问时提供的替代通道，常见于网络环境波动或服务调整期间。它的内容与主入口一致，差别主要在访问路径。使用备用地址时，同样要确认来源，避免把仿冒页面当成官方备用入口。',
    points: [
      '备用地址一般与主入口内容同步，出现明显差异时要谨慎',
      '优先选择官方说明中提到的备用通道，而非群里随手转发的短链',
      '打开后先确认页面整体观感是否与主入口一致，再继续操作',
      '若多个备用地址都无法打开，多半是整体在调整，耐心等待更新',
    ],
    note: '备用地址的可用性会随网络环境变化，遇到打不开属正常情况，不必反复尝试可疑链接。',
  },
  {
    key: 'mobile',
    label: '移动端入口',
    icon: 'ri-smartphone-line',
    headline: '移动端入口：手机上访问的注意事项',
    desc: '移动端入口针对手机和平板浏览做了适配，文字与按钮更大、操作更贴合触屏习惯。在手机上下载来源不明的安装包、点击短信里的陌生短链，是移动端最常见的风险来源，需要格外留意。',
    points: [
      '只通过官方公布的移动端入口访问，不安装来路不明的应用包',
      '短信、聊天软件里未经确认的短链不要直接点击',
      '公共网络下尽量不进行账号相关操作，避免信息被截取',
      '手机浏览器提示证书异常时，应立即停止操作并核实来源',
    ],
    note: '移动端便捷但也更容易误点，遇到要求下载、授权通讯录的页面请先退出再判断。',
  },
];

export const changeReasons = [
  {
    icon: 'ri-link-m',
    title: '域名与地址调整',
    desc: '出于运营安排或技术维护的需要，站点地址有时会做调整。调整期间旧地址可能暂时或永久失效，这也是「最新地址」被反复提到的原因。',
  },
  {
    icon: 'ri-earth-line',
    title: '不同地区访问差异',
    desc: '同一时间、不同网络环境下的访问结果可能并不一致。某条线路打不开，不代表所有入口都失效，换一条通道往往就能恢复。',
  },
  {
    icon: 'ri-shield-cross-line',
    title: '仿冒页面干扰',
    desc: '一些与官方无关的页面会模仿相似的外观，用相近的名称吸引点击。它们往往在细节处露出破绽，确认来源是最好的防线。',
  },
  {
    icon: 'ri-time-line',
    title: '信息更新存在延迟',
    desc: '入口信息从变动到被各方同步需要一点时间。如果看到的说明与实际情况对不上，可能只是更新还没跟上，而非信息错误。',
  },
];

export const visitSteps = [
  {
    step: '01',
    icon: 'ri-search-eye-line',
    title: '先确认信息来源',
    desc: '在动手访问前，先想清楚这条入口信息来自哪里。官方公布、可信渠道的信息优先，来路不明的转发先放一放。',
  },
  {
    step: '02',
    icon: 'ri-list-check-2',
    title: '核对入口类型',
    desc: '分清自己要找的是官网入口、备用地址还是移动端入口。不同类型的适配场景不一样，选对了能少走弯路。',
  },
  {
    step: '03',
    icon: 'ri-lock-line',
    title: '检查页面安全标识',
    desc: '打开页面后，先看地址栏与整体观感是否正常。出现无关弹窗、强制下载、要求额外付费时，立即停止操作。',
  },
  {
    step: '04',
    icon: 'ri-key-2-line',
    title: '谨慎填写账号信息',
    desc: '只在确认无误的页面上输入账号相关的内容。任何以「验证身份」为由索要密码、验证码的页面都要高度警惕。',
  },
  {
    step: '05',
    icon: 'ri-logout-box-r-line',
    title: '异常时及时退出',
    desc: '一旦发现页面行为异常，直接关闭并不再回访。如有疑问，先回到官方渠道确认，再决定是否继续。',
  },
];

export const securityTips = [
  {
    icon: 'ri-vip-crown-2-line',
    title: '认准官方渠道',
    desc: '把官方公布的入口作为唯一可信来源，减少对第三方转发的依赖，从源头上降低误入仿冒页面的概率。',
  },
  {
    icon: 'ri-alarm-warning-line',
    title: '警惕仿冒页面',
    desc: '仿冒页常在外观上模仿官方，却在细节上露出破绽。名称相似、界面粗糙、弹窗频繁，都是值得警惕的信号。',
  },
  {
    icon: 'ri-lock-password-line',
    title: '保护账号与密码',
    desc: '不要让同一个密码被多个站点共用。任何正规页面都不会主动向你索要密码原文或短信验证码。',
  },
  {
    icon: 'ri-link-unlink-m',
    title: '留意链接与证书',
    desc: '点击链接前先看清去向，浏览器提示证书异常或页面被标记为不安全时，不要强行继续。',
  },
  {
    icon: 'ri-spam-2-line',
    title: '不轻信陌生推广',
    desc: '以「加速」「内测」「内部通道」为名的推广，多数与官方无关。越是催促你立刻行动，越要慢下来核实。',
  },
  {
    icon: 'ri-computer-line',
    title: '留意设备与浏览器',
    desc: '保持浏览器与系统更新，尽量使用常见的正规浏览器，及时关闭来源不明的插件与弹窗。',
  },
];

export const faqCategories = [
  { key: 'all', label: '全部' },
  { key: 'basic', label: '入门' },
  { key: 'address', label: '地址' },
  { key: 'access', label: '访问' },
  { key: 'safety', label: '安全' },
];

export const faqItems = [
  {
    category: 'basic',
    q: '香蕉社区是一个什么样的社区？',
    a: '从公开信息看，香蕉社区是一个以线上交流为主的社区名称。本页并不介绍其具体内容，而是围绕「官网入口、网址首页、最新地址」等访问相关问题做整理，帮助需要访问的人找到相对可靠的入口线索。',
  },
  {
    category: 'basic',
    q: '本站和香蕉社区是什么关系？',
    a: '本站是一份独立整理的信息页，把与访问相关的常见问题集中呈现，方便快速查阅。本站不代替官方发布入口，所有地址的最终可用性都以官方渠道为准。',
  },
  {
    category: 'address',
    q: '为什么网站地址会经常变动？',
    a: '地址变动通常与运营安排、技术服务调整或网络环境差异有关。当旧地址暂时不可用时，就会出现新的入口。这也是「最新地址」被反复提及的原因，而不代表站点本身发生了什么特殊变化。',
  },
  {
    category: 'address',
    q: '最新地址应该去哪里查看？',
    a: '建议以官方公开渠道为准。若你保存的地址失效，可以先确认官方是否有新的说明，再选择备用通道。对来源不明的「最新地址」列表，务必先核实再使用。',
  },
  {
    category: 'address',
    q: '官网入口和备用地址有什么区别？',
    a: '两者内容一般是一致的，差别主要在访问路径。官网入口是主通道，可信度最高；备用地址在主通道暂时不可用时作为替代。无论是哪一种，都要先确认来源是否可靠。',
  },
  {
    category: 'access',
    q: '页面打不开怎么办？',
    a: '先判断是个别线路问题还是整体调整。可以换一条官方公布的通道，或稍后再试。如果多个入口同时无法打开，多半是整体在调整，此时不必反复点击来源可疑的链接。',
  },
  {
    category: 'access',
    q: '为什么不同地区访问结果不一样？',
    a: '不同网络环境下的连通情况本就存在差异。某条线路在你这里打不开，在别处可能正常。遇到这种情况，换用其他官方通道往往更有效，而不是怀疑信息本身有误。',
  },
  {
    category: 'safety',
    q: '收到陌生链接可以直接点开吗？',
    a: '不建议直接点开。先看清发件人或发送者是否可信，再判断链接去向。以「账号异常」「限时验证」为由催促你点击的，绝大多数与官方无关，应直接忽略。',
  },
  {
    category: 'safety',
    q: '如何判断自己访问的是不是官网？',
    a: '可以从来源、外观与行为三方面判断：来源是否来自官方公布；外观是否结构完整、视觉统一；行为是否出现强制跳转、弹窗或索要敏感信息。三点中任意一点异常，都应先停下来核实。',
  },
  {
    category: 'safety',
    q: '在公共设备上可以登录吗？',
    a: '不建议。公共电脑或他人设备可能留有记录，登录相关操作应尽量在自己的设备上完成。若确需临时使用，操作结束后记得退出并清除浏览记录。',
  },
];

export const updateScenarios = [
  {
    icon: 'ri-calendar-event-line',
    tag: '常见情况',
    title: '域名到期或地址调整',
    desc: '当站点地址发生更换时，原有入口可能逐步失效，新地址会在官方渠道公布。此时留意官方说明即可，不必轻信外部清单。',
  },
  {
    icon: 'ri-tools-line',
    tag: '维护期间',
    title: '服务升级与维护',
    desc: '系统维护或功能升级期间，部分入口可能短暂无法访问。多数情况下稍后即可恢复，期间不建议尝试来源不明的替代页面。',
  },
  {
    icon: 'ri-megaphone-line',
    tag: '渠道变化',
    title: '入口渠道的更新',
    desc: '官方对外公布的入口渠道本身也可能调整。养成以官方为准的习惯，就能在渠道变化时第一时间找到正确方向。',
  },
  {
    icon: 'ri-shield-flash-line',
    tag: '安全策略',
    title: '安全提示的加强',
    desc: '当风险上升时，官方往往会加强安全提示。看到新的验证提醒不必惊慌，按官方说明操作即可，切勿向陌生页面透露验证码。',
  },
];

export const contactChannels = [
  {
    icon: 'ri-question-answer-line',
    title: '使用疑问',
    desc: '如果你对入口类型、地址变动的说明还有不明白的地方，建议先通读本页的「常见问题」区块，多数疑问都能在其中找到答案。',
  },
  {
    icon: 'ri-error-warning-line',
    title: '信息纠错',
    desc: '如果发现本页的描述与你的实际体验出入较大，请以官方渠道为准。本站的说明仅作为一般性参考，会随情况整理更新。',
  },
  {
    icon: 'ri-parentheses-line',
    title: '免责声明',
    desc: '本站为独立的信息整理页，不提供任何入口的直接跳转，也不代表官方立场。请自行核实来源，并对访问行为负责。',
  },
];

export const footerColumns = [
  {
    title: '快速导航',
    links: [
      { id: 'about', label: '社区简介' },
      { id: 'entrance', label: '入口类型' },
      { id: 'reason', label: '地址变动' },
      { id: 'guide', label: '访问指南' },
    ],
  },
  {
    title: '更多内容',
    links: [
      { id: 'security', label: '安全提示' },
      { id: 'faq', label: '常见问题' },
      { id: 'updates', label: '更新说明' },
      { id: 'contact', label: '反馈帮助' },
    ],
  },
];